<template>
  <div class="loading-mask">
    <a-spin :tip="getLabel('TIP_WAITING')" size="large"></a-spin>
  </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Language from '../util/language';

	export default {
		components: {},
		computed: {
			...mapState({
				language: state => state.main.language
			})
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			}
		}
	};
</script>

<style lang="less" scoped>
  .loading-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    z-index: 100;
    background: rgba(0, 0, 0, 0.65);
    .ant-spin {
      top: 50%;
      position: absolute;
      transform: translateY(-50%);
    }
  }
</style>